@if (operation?.config) {
<tec-collapse [title]="`WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS` | translate" [badge]="index.toString()">
    <app-developer-curl-button
        ngProjectAs="tec-button-icon"
        [path]="operationCurlPath()"
        titleKey="WORKFLOWS.CURL_MODAL.TITLE_OPERATION"
    />
    <tec-tile
        [title]="'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS_METHOD' | translate"
        [subtitle]="'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS_DESCRIPTION' | translate"
    >
        <div class="grid grid-i2">
            <tec-card-select
                [tagImg]="{img: 'images/workflow-attorney-powers-unselect.png', status: 'default'}"
                [title]="'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS' | translate"
                [description]="`WORKFLOWS.FORM.OPERATIONS.${operation.type === OPERATION_TYPE.CONNECTIONS ? 'ATTORNEY_POWERS_AUTO_DESCRIPTION' : 'ATTORNEY_POWERS_MANUAL_DESCRIPTION'}` | translate"
                [tags]="[operation.type === OPERATION_TYPE.CONNECTIONS ?
                    { label: 'WORKFLOWS.DETAIL.AUTOMATIC' | translate | uppercase, status: 'success' }
                    : { label: 'WORKFLOWS.DETAIL.MANUAL' | translate | uppercase, status: 'success' }]"
                [selected]="true"
                [disabled]="true"
            />
        </div>
    </tec-tile>

    <tec-tile [title]="'WORKFLOWS.FORM.CONF_ADVANCED' | translate">
        <tec-info-group
            [label]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIED' | translate"
            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIED_TOOLTIP' | translate"
        >
            <tec-badge [label]="'3'" type="square" />
        </tec-info-group>
    </tec-tile>
</tec-collapse>
}
